import "./Currency.css";

import Input from "../Input/Input";


export default function Currency({fldName, form, fldDef, opts}){
    return <Input
        fldName={fldName}
        form={form}
        fldDef={fldDef}
        opts={{...opts, datalist:[
            ['RMB','人民币'],
            'CAD',
            'USD'
        ]}}
    ></Input>;
}